<template>
  <div>
    <template v-if="!$Tools.empty(courseOutline.children)">
      <div
        class="course_subChapter"
        v-for="(sitem, sindex) in courseOutline.children"
        :key="sindex"
        :class="{ expanded: sitem.isExpanded }"
      >
        <div class="course_one">
          <div class="subChapter_top flex FlexBetween Flexalign" v-if="sitem.children">
            <div class="flex Flexalign subChapter_top_left flex-1 toverflow">
              <div class="subChapter_top_left_subChapter mar_top_10">
                {{ sitem.chapterName }}
              </div>
            </div>
          </div>
          <div class="subChapterList" v-else>
            <div
              class="subChapterList_one cursor_pointer"
              :class="[courseValue == sitem.chapterId ? 'active_subChapterList_one' : '']"
            >
              <div class="flex Flexalign flex-1 toverflow">
                <el-image
                  class="show_wheel cursor_pointer"
                  :src="iconPath('show_wheel.png')"
                  @click="changeWheel(sitem.chapterId)"
                  :class="[sitem.phaseVoList.length?'':'show_wheel_empty']"
                ></el-image>
                <!-- 目录 -->
                <div
                  class="toverflow cursor_pointer"
                  @click="changeWheel(sitem.chapterId)"
                >
                  {{ sitem.chapterName }}
                </div>

                <div class="free_view_box ml-10" v-if="sitem.freeLearning == 1">
                  免费试学
                </div>
                <!-- <div class="btn_free" v-if="sitem.freeLearning == 1" @click="goFreeLearning()">免费试看</div> -->
              </div>
              <div class="wheel_list" v-if="sitem.wheel">
                <div v-for="(wheel, wheelIndex) in sitem.phaseVoList" :key="wheelIndex">
                  <div
                    class="wheel_one flex Flexalign FlexBetween px-20"
                    :class="[
                      selectWheelValue == wheel.id ? 'active_subChapterList_one' : '',
                    ]"
                    @mouseenter="selectCourseWheel(wheel)"
                    @mouseleave="selectCourseWheel('')"
                    v-if="wheel.enabled == 1"
                  >
                    <div class="flex Flexalign">
                      <el-image
                        class="wheel_active"
                        :src="iconPath('wheel_active.png')"
                        v-if="wheel.id == selectWheelValue"
                      ></el-image>
                      <div class="wheel_active" v-else></div>
                      <div class="ml-5">{{ phaseList[wheel.phaseId] }}</div>
                      <el-image
                        class="free_view_icon flex Flexalign cursor_pointer ml-10"
                        :src="iconPath('free_view_icon.png')"
                        v-if="
                          wheel.chapterResource?.previewUsable == 1 &&
                          wheel.id == selectWheelValue
                        "
                        @click="videoFree(wheel)"
                      ></el-image>
                    </div>
                    <div
                      class="btn_learn cursor_pointer"
                      v-if="wheel.id == selectWheelValue"
                    >
                      <div
                        v-if="courseInfo?.saleMethod == 1"
                        @click="
                          goLearning(
                            isAleadyJoin ? 'buy' : 'free',
                            sitem.courseId,
                            sitem.chapterId,
                            wheel.phaseId,
                            sitem
                          )
                        "
                      >
                        {{ isAleadyJoin ? "开始学习" : "免费参与学习" }}
                      </div>
                      <div
                        v-if="
                          courseInfo?.saleMethod == 2 &&
                          isAleadyJoin &&
                          sitem.freeLearning == 2
                        "
                        @click="
                          goLearning(
                            'buy',
                            sitem.courseId,
                            sitem.chapterId,
                            wheel.phaseId,
                            sitem
                          )
                        "
                      >
                        开始学习
                      </div>
                      <div
                        class=""
                        v-if="sitem.freeLearning == 1"
                        @click="
                          goLearning(
                            'buy',
                            sitem.courseId,
                            sitem.chapterId,
                            wheel.phaseId,
                            sitem,
                            'freeLearning'
                          )
                        "
                      >
                        免费试学
                      </div>
                      <div
                        v-if="
                          courseInfo?.saleMethod == 2 &&
                          isAleadyJoin == false &&
                          sitem.freeLearning == 2
                        "
                        @click="addCar(2, sitem.courseId)"
                      >
                        立即购买
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="sitem.children">
          <courseTitleList
            :courseOutline="sitem"
            :courseValue="courseValue"
            @changeCourseValue="changeCourseValue"
            :courseDetail="courseDetail"
            :isAleadyJoin="isAleadyJoin"
            @showWheel="showWheel"
          >
          </courseTitleList>
        </div>
      </div>
    </template>
    <template v-if="$Tools.empty(courseOutline.children)">
      <div class="subChapterList">
        <div
          class="subChapterList_one cursor_pointer"
          :class="[
            courseValue == courseOutline.chapterId ? 'active_subChapterList_one' : '',
          ]"
        >
          <div class="flex Flexalign flex-1 toverflow">
            <el-image
              class="show_wheel cursor_pointer"
              :src="iconPath('show_wheel.png')"
              @click="changeWheel(courseOutline.chapterId)"
              :class="[courseOutline.phaseVoList.length?'':'show_wheel_empty']"
            ></el-image>
            <!-- 目录 -->
            <div
              class="toverflow cursor_pointer"
              @click="changeWheel(courseOutline.chapterId)"
            >
              {{ courseOutline.chapterName }}
            </div>
            <!-- <div v-if="courseOutline.freeLearning == 1">免费试看</div> -->
            <div class="free_view_box ml-10" v-if="courseOutline.freeLearning == 1">
              免费试学
            </div>
          </div>
          <div class="wheel_list" v-if="courseOutline.wheel">
            <div
              v-for="(wheel, wheelIndex) in courseOutline.phaseVoList"
              :key="wheelIndex"
            >
              <div
                class="wheel_one flex Flexalign FlexBetween px-20"
                :class="[selectWheelValue == wheel.id ? 'active_subChapterList_one' : '']"
                @mouseenter="selectCourseWheel(wheel)"
                @mouseleave="selectCourseWheel('')"
                v-if="wheel.enabled == 1"
              >
                <div class="flex Flexalign">
                  <el-image
                    class="wheel_active"
                    :src="iconPath('wheel_active.png')"
                    v-if="wheel.id == selectWheelValue"
                  ></el-image>
                  <div class="wheel_active" v-else></div>
                  <div class="ml-5">{{ phaseList[wheel.phaseId] }}</div>
                  <el-image
                    class="free_view_icon flex Flexalign cursor_pointer ml-10"
                    :src="iconPath('free_view_icon.png')"
                    v-if="
                      wheel.chapterResource?.previewUsable == 1 &&
                      wheel.id == selectWheelValue
                    "
                    @click="videoFree(wheel)"
                  ></el-image>
                </div>
                <div class="btn_learn cursor_pointer" v-if="wheel.id == selectWheelValue">
                  <div
                    v-if="courseInfo?.saleMethod == 1"
                    @click="
                      goLearning(
                        isAleadyJoin ? 'buy' : 'free',
                        courseOutline.courseId,
                        courseOutline.chapterId,
                        wheel.phaseId,
                        courseOutline
                      )
                    "
                  >
                    {{ isAleadyJoin ? "开始学习" : "免费参与学习" }}
                  </div>
                  <div
                    v-if="
                      courseInfo?.saleMethod == 2 &&
                      isAleadyJoin &&
                      courseOutline.freeLearning == 2
                    "
                    @click="
                      goLearning(
                        'buy',
                        courseOutline.courseId,
                        courseOutline.chapterId,
                        wheel.phaseId,
                        courseOutline
                      )
                    "
                  >
                    开始学习
                  </div>
                  <div
                    class=""
                    v-if="courseOutline.freeLearning == 1"
                    @click="
                      goLearning(
                        'buy',
                        courseOutline.courseId,
                        courseOutline.chapterId,
                        wheel.phaseId,
                        courseOutline,
                        'freeLearning'
                      )
                    "
                  >
                    免费试学
                  </div>
                  <div
                    v-if="
                      courseInfo?.saleMethod == 2 &&
                      isAleadyJoin == false &&
                      courseOutline.freeLearning == 2
                    "
                    @click="addCar(2, courseOutline.courseId)"
                  >
                    立即购买
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <buyFreeCourse ref="buyFreeCourse"></buyFreeCourse>
    <videoDialog ref="videoDialog" :selectedVideo="selectedVideo"></videoDialog>
  </div>
</template>

<script>
import buyFreeCourse from "@/components/popup/buyFreeCourse.vue";
import videoDialog from "@/components/popup/videoDialog.vue";
import { mapState } from "vuex";
export default {
  name: "GjkcH5CourseTitleList",
  props: {
    courseOutline: {},
    courseValue: {},
    courseDetail: {},
    isAleadyJoin: {},
  },
  watch: {
    courseDetail: {
      handler(val) {
        if (val) {
          this.courseInfo = this.$Tools.copyObj(this.courseDetail);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  components: {
    buyFreeCourse,
    videoDialog,
  },
  computed: {
    ...mapState({
      phaseList: (state) => state.learning.phaseList,
    }),
  },

  data() {
    return {
      courseInfo: {},
      selectedVideo: "",
      selectWheelValue: "",
    };
  },

  mounted() {},

  methods: {
    videoFree(info) {
      this.$refs.videoDialog.videoShow = true;
      this.selectedVideo = info?.chapterResource?.previewVideoPath;
      this.$refs.videoDialog.selectedVideoInfo = info;
    },
    changeWheel(chapterId) {
      this.$emit("showWheel", this.courseOutline.children, chapterId);
    },
    showWheel(nodes, chapterId) {
      this.$emit("showWheel", nodes, chapterId);
    },
    // 收起课程大纲
    retractChapter(info) {
      info.isExpanded = !info.isExpanded;
      this.$emit("checkOverflow");
    },
    // 选中章节
    selectCourseChapter(info) {
      this.$emit("changeCourseValue", info?.chapterId);
    },
    selectCourseWheel(info) {
      this.selectWheelValue = info?.id;
    },
    changeCourseValue(info) {
      this.$emit("changeCourseValue", info);
    },
    // 去学习
    // goLearning(courseId) {
    //   // if((this.courseDetail.saleMethod == 1 && this.isAleadyJoin) || (this.courseDetail.saleMethod == 2 && this.isAleadyJoin)){
    //     this.$Jump.href("/onlineLearning", { courseId, menuValue: 2 });
    //   // }else{

    //   // }
    // },
    // 去学习
    goLearning(type, courseId, chapterId, wheelId, info, learningType) {
      if (type == "free") {
        // 调接口免费学习后再弹窗
        this.$Api.course
          .joinFreeCourse({ courseId: courseId })
          .then(() => {
            this.$refs.buyFreeCourse.buyFreeCourseShow = true;
            this.$refs.buyFreeCourse.courseId = courseId;
            // this.$Jump.href("/onlineLearning", { courseId: this.courseId });
          })
          .catch(() => {});
      } else {
        if (info) {
          // 新增判断，判断起始时间是否配置，配置起始时间需判断是否在该时间段，若在该时间段才可切换，否则不可以切换
          if (info.openEndTime && info.openBeginTime) {
            const startTime = new Date(info.openBeginTime).getTime();
            const endTime = new Date(info.openEndTime).getTime();
            const nowTime = new Date().getTime();
            if (nowTime >= startTime && nowTime < endTime) {
              console.log("");
            } else {
              this.$Dialog.toast("视频未到开放时间，请查看课表", {
                type: "warning",
              });
              return;
            }
          }
          // 若只配置开始时间
          if (info.openBeginTime && !info.openEndTime) {
            const startTime = new Date(info.openBeginTime).getTime();
            const nowTime = new Date().getTime();
            if (nowTime < startTime) {
              this.$Dialog.toast("视频未到开放时间，请查看课表", { type: "warning" });
              return;
            }
          }
          // 若只配置结束时间
          if (info.openEndTime && !info.openBeginTime) {
            const endTime = new Date(info.openEndTime).getTime();
            const nowTime = new Date().getTime();
            if (nowTime > endTime) {
              this.$Dialog.toast("视频未到开放时间，请查看课表", { type: "warning" });
              return;
            }
          }
        }
        // 选中的章节
        this.$store.commit('learning/setSelectLearningInfo', info);
        this.$Jump.href("/onlineLearning", {
          courseId: courseId,
          menuValue: 2,
        });
        // 用于触发在线学习章节列表选中的方法
        this.$store.commit("learning/setSelectedChapterInfo", {
          chapterId,
          wheelId,
        });
        // 免费试学在缓存中添加下标识
        if (learningType == "freeLearning") {
          this.$store.commit("learning/setIsFreeLearning", true);
        } else {
          this.$store.commit("learning/setIsFreeLearning", false);
        }
      }
    },
    // 加入购物车
    addCar(type, courseId) {
      this.$Api.shop
        .addCar({ courseId: courseId, type: type })
        .then((res) => {
          console.log(res);
          if (type == 1) {
            this.$Dialog.toast("加入购物车成功");
            this.getCarList();
          } else {
            // this.$Jump.href("/cart");
            // let selectOrderList = [{ courseInfo: this.courseDetail }];
            // this.$Jump.href("/orderConfirm", {
            //   selectOrderList: JSON.stringify(selectOrderList),
            // });
            this.$Jump.href("/orderConfirm", { type: 2 });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.course_subChapter {
  // max-height: 36px;
  // overflow: hidden;

  // margin-top: 15px;
  //   margin-left: 40px;
  .course_one {
    // margin-top: 15px;
    margin-left: 40px;
  }

  // .course_one_max {
  //   max-height: 32px;
  //   overflow: hidden;
  // }

  .subChapter_top {
    // margin-top: 15px;

    .subChapter_top_left_subChapter {
      // margin-left: 5px;
      color: #333333;
      font-size: 18px;
      font-weight: 600;
    }
  }
}

.subChapterList {
  // margin-top: 10px;
  // margin-left: 40px;

  .subChapterList_one {
    padding: 0 10px;
    line-height: 34px;
    color: #999999;

    .show_wheel {
      margin-right: 10px;
      width: 14px;
      height: 14px;
    }
    .show_wheel_empty{
      opacity: 0;
    }

    .btn_free {
      padding: 0 10px;
      background: linear-gradient(90deg, #00d5c2, #00d498);
      border-radius: 18px;
      color: #ffffff;
      font-size: 14px;
      line-height: 30px;
    }

    .free_view_icon {
      width: 80px;
      margin-left: 10px;
    }

    .btn_learn {
      min-width: 80px;
      height: 28px;
      font-size: 14px;
      background: linear-gradient(90deg, #00d5c2, #00d498);
      border-radius: 17px;
      color: #ffffff;
      line-height: 28px;
      margin-right: 10px;
      text-align: center;
      padding: 0 10px;
    }
  }

  .active_subChapterList_one {
    background: #fafcff;
    color: #13d6aa;
  }

  .wheel_list {
    .wheel_one {
      .wheel_active {
        width: 28px;
        height: 28px;
      }
    }
  }
}

.course_subChapter.expanded {
  max-height: none;
  overflow: visible;

  .course_subChapter {
    max-height: 54px;
  }

  /* 展开后高度 */
  .subChapterList_one {
    padding: 5px 10px;
  }
}

.free_view_box {
  width: 59px;
  height: 25px;
  background: #fe5e3c;
  border-radius: 45px 45px 45px 2px;
  font-size: 12px;
  color: #ffffff;
  line-height: 25px;
  text-align: center;
}
</style>
